import segmentProps from '../lib/segmentProps';

export default {
    providers: {
        segment: {
            type: 'track',
            name: 'fe_filter_clicked',
            props: {
                ...segmentProps,
                search_id: '#context.searchId',
                vertical: '#context.verticalId',
                previously_filtered: '#context.previouslyFiltered',
                number_of_results: '#context.remainingResults',
            },
        },
    },
};
